/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCalculationResultDto } from '../../models/backend-calculation-result-dto';

export interface ProjectCalculationsCalculationResultsRetrieve$Params {
  id: string;
}

export function projectCalculationsCalculationResultsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: ProjectCalculationsCalculationResultsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCalculationResultDto>> {
  const rb = new RequestBuilder(rootUrl, projectCalculationsCalculationResultsRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCalculationResultDto>;
    }),
  );
}

projectCalculationsCalculationResultsRetrieve.PATH = '/api/project_calculations/calculation_results/{id}/';
